var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9141 17.3199L22.4154 20.1466L18.2738 16.27L22.2386 12.5589L22.3239 12.6016L22.3248 12.6008L22.4239 12.6517L22.503 12.6914L22.5023 12.692L27.9138 15.4729C28.3522 15.6781 28.5714 15.9858 28.5714 16.2935C28.5714 16.3276 28.5687 16.3617 28.5633 16.3957C28.5688 16.4301 28.5716 16.4647 28.5716 16.4993C28.5716 16.807 28.3524 17.1148 27.9141 17.3199ZM20.9705 11.9236L6.76676 4.80741L6.76338 4.80567C6.44057 4.60424 6.22341 4.5017 5.69695 4.49805L17.3003 15.3589L20.9705 11.9236ZM16.3269 16.27L4.61982 5.31214C4.58867 5.41215 4.57159 5.51762 4.57159 5.62628V16.3967V27.273L16.3269 16.27ZM5.29084 28.4221C5.41174 28.4727 5.53962 28.5007 5.66749 28.5007C6.14267 28.5007 6.45302 28.3464 6.67001 28.2385C6.70324 28.222 6.73427 28.2066 6.76338 28.1929L21.1588 20.7926L17.3003 17.1812L5.29084 28.4221Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceGoogle);
export default __webpack_public_path__ + "static/media/deviceGoogle.404cfc1b644b3de705b4d601a607abb7.svg";
export { ForwardRef as ReactComponent };